<button type="button" mat-flat-button class="mic-btn-icon-left" (click)="onExportClick()" [disabled]="isExporting">
  <mat-icon>table_view</mat-icon>
  {{ isExporting ? 'Exporting...' : 'Excel' }}
</button>
